import React from 'react'
import { Link } from 'react-router-dom'
import {FileText} from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-[#1F2937] text-gray-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 text-white font-bold text-xl mb-4">
              <FileText className="w-6 h-6" />
              <span>Invoice Me Now</span>
            </div>
            <p className="text-sm text-gray-400">
              Free, instant invoice generator for freelancers, contractors, and small businesses.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/templates" className="hover:text-white transition-colors">Templates</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Resources</Link></li>
            </ul>
          </div>

          {/* Invoice Types */}
          <div>
            <h3 className="text-white font-semibold mb-4">Invoice Types</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/invoice-types/proforma" className="hover:text-white transition-colors">Proforma Invoice</Link></li>
              <li><Link to="/invoice-types/tax" className="hover:text-white transition-colors">Tax Invoice</Link></li>
              <li><Link to="/invoice-types/medical" className="hover:text-white transition-colors">Medical Invoice</Link></li>
              <li><Link to="/invoice-types/legal" className="hover:text-white transition-colors">Legal Invoice</Link></li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="text-white font-semibold mb-4">Industries</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/industries/plumbing" className="hover:text-white transition-colors">Plumbing</Link></li>
              <li><Link to="/industries/catering" className="hover:text-white transition-colors">Catering</Link></li>
              <li><Link to="/industries/handyman" className="hover:text-white transition-colors">Handyman</Link></li>
              <li><Link to="/industries/auto-repair" className="hover:text-white transition-colors">Auto Repair</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Invoice Me Now. All rights reserved. | Free instant invoice generator tool.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
